export default "__VITE_ASSET__BTYJR61X__"